import { RefreshCw } from "lucide-react";
import { useEffect, useState } from "react";

import { api } from "@/api";

export const SyncChip = () => {
  const [st, setSt] = useState(null);
  useEffect(() => {
    const load = () => api.get("/pipeline/sync-status").then(({ data }) => setSt(data)).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);
  if (!st?.pending) return null;
  return (
    <span className="pl-sync-chip" title={st.last_error ? `Dernière erreur noCRM : ${st.last_error}` : "Les changements sont enregistrés ici et recopiés automatiquement dans noCRM."} data-testid="pipeline-sync-chip">
      <RefreshCw size={12} /> {st.pending} changement{st.pending > 1 ? "s" : ""} en attente de copie vers noCRM
    </span>
  );
};
